import { type FC } from 'react';
import { useTranslation } from 'react-i18next';

import { TermsLink } from '@/components/Ad/TermsLink/TermsLink';
import { ButtonType } from '@/components/AdvertisePayments/components/Footer/Footer.types';
import { PAYMENT_MODAL_CY } from '@/constants/test-id';
import { useAbove } from '@/hooks/useAbove';
import { useThemeMode } from '@/hooks/useThemeMode';

import * as S from './Footer.styles';

type PayWithDisclaimerFooterProps = {
  onPay?: () => void;
  isLoading?: boolean;
  disabled?: boolean;
  isAddBalance?: boolean;
};

export const PayWithDisclaimerFooter: FC<PayWithDisclaimerFooterProps> = ({
  onPay,
  disabled,
  isLoading = false,
  isAddBalance
}) => {
  const { t } = useTranslation();
  const isDark = useThemeMode('dark');
  const isTabletOrAbove = useAbove('tablet');
  const isDisabled = isLoading || disabled;
  const btnText = isAddBalance
    ? t('Advertise.btn_top_up_balance')
    : t('Advertise.btn_pay');

  return (
    <S.FooterWrapper>
      <S.ContentColumn>
        <S.ActionButton
          as="button"
          $isDark={isDark}
          $type={ButtonType.DEFAULT}
          $isLoading={isLoading}
          disabled={isDisabled}
          aria-disabled={isDisabled}
          onClick={isDisabled ? undefined : onPay}
          data-cy={PAYMENT_MODAL_CY.CONFIRM_BTN}
        >
          {isLoading ? (
            <S.SpinnerWrapper>
              <S.Spinner />
            </S.SpinnerWrapper>
          ) : (
            <S.ActionButtonLabel $isDark={isDark} $type={ButtonType.DEFAULT}>
              {btnText}
            </S.ActionButtonLabel>
          )}
        </S.ActionButton>

        {isTabletOrAbove && <TermsLink />}
      </S.ContentColumn>
    </S.FooterWrapper>
  );
};
